// src/containers/Organization/pages/ScheduleDetail/index.tsx
import React, { useEffect, useState } from 'react'
import { Container } from '../../../../components'
import { Button, Tab, Tabs, useTheme } from '@material-ui/core'
import {
    LeaseAudit,
    LeaseAuditEvent,
    LeaseAuditSchedule,
} from '../../../../models/DocumentAudit/types'
import { useParams } from 'react-router-dom'
import { axiosInstance } from '../../../../helpers'
import { useAuditEvents, useLeaseAudit } from '../../../../hooks/documentAudit'
import { useUser } from '../../../../hooks/useUser'
import { useAuditEventDetail } from '../../../../hooks/documentAudit/useEventDetail'
import { LeasePage } from '../../../LeaseAudit/Pages/LeasePage'

interface Props {
    schedule: LeaseAuditSchedule
}

export const LeaseAuditScheduleDetail: React.FC<Props> = () => {
    const { id } = useParams<{ id: string }>()
    // const { organizationId } = useOrganization()

    const { organization } = useUser()

    const theme = useTheme()

    const [selectedCompany, setSelectedCompany] = useState<number>(-1)

    const { event } = useAuditEventDetail(organization ?? -1, parseInt(id))

    // useEffect(() => {
    //     if (events) {
    //         setEvent(events.find((event) => event.id === parseInt(id)) ?? null)
    //     }
    // }, [events])

    // const handleLoad = (id: string) => {
    //     axiosInstance
    //         .get(`/document-audit/schedule-event/${id}/`)
    //         .then((res: any) => {
    //             const event: LeaseAuditEvent = res.data

    //             setEvent(event)

    //             if (event.lease_audits.length > 0) {
    //                 setSelectedCompany(event.lease_audits[0].id)
    //             }
    //         })
    // }

    // useEffect(() => {
    //     handleLoad(id)
    // }, [id])

    const leaseAuditController = useLeaseAudit()

    useEffect(() => {
        if (selectedCompany !== -1 && organization) {
            leaseAuditController.fetchLeaseAudit(selectedCompany, organization)
        }
    }, [selectedCompany])

    return (
        <Container
            style={{
                width: '100%',
                height: '100%',
                flexDirection: 'column',
                padding: theme.spacing(2),
            }}
        >
            <Container>
                <Tabs
                    value={selectedCompany}
                    onChange={(_, value) => setSelectedCompany(value)}
                >
                    {event?.lease_audits.map((leaseAudit: LeaseAudit) => {
                        return (
                            <Tab
                                label={leaseAudit.apartment.name}
                                key={leaseAudit.id}
                                value={leaseAudit.id}
                                onClick={() =>
                                    setSelectedCompany(leaseAudit.id)
                                }
                            />
                        )
                    })}
                </Tabs>
            </Container>

            <LeasePage
                leaseAuditController={leaseAuditController}
                theme={theme}
                height={bodyH}
            />

            {/* Add your detail view content here */}
        </Container>
    )
}

const containerH = window.innerHeight - 104

const headerH = 60
const bodyH = containerH - headerH
